var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-time.cf5a333e.png","uri@2x": __webpack_public_path__ + "icon-time.e801aac7.png","uri@3x": __webpack_public_path__ + "icon-time.65cb932f.png",
    width: 29,
    height: 29
});